<template>
  <div id="app">
    <router-view />
    <mc-login
      v-if="showLoginBox"
      @closeLogin="close"
      @getUserInfo="getUserInfo"
    ></mc-login>
    <IayoutUseIcveFooter></IayoutUseIcveFooter>
  </div>
</template>

<script>
import IayoutUseIcveFooter from "@/components/layout-use-icve-footer";
import McLogin from "@/components/mc-login";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },
  components: {
    IayoutUseIcveFooter,
    McLogin
  },
  computed: {
    ...mapState(["showLoginBox"])
  },
  mounted() {
    this.judgeLogoin();
  },
  methods: {
    ...mapMutations(["changeShowLoginBox", "setUserInfo", "changeIsLogin"]),
    close() {
      this.changeShowLoginBox(false);
    },
    /**获取用户信息 */
    getUserInfo(data) {
      if (data.code === 1) {
        this.changeShowLoginBox(false);
        this.judgeLogoin();
      }
    },
    /**页面加载判断是否已登录 */
    judgeLogoin() {
      this.$http.post("/api/common/login/GetUserInfo").then(res => {
        if (res.code === 1) {
          this.setUserInfo(res);
          this.changeIsLogin(true);
        }
      });
    }
  }
};
</script>
